import BuildIcon from '@mui/icons-material/Build';
import { Box, Typography } from '@mui/material';
import React from 'react';

const MaintenancePage = () => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: '#f5f5f5',
      textAlign: 'center',
      px: 3,
    }}
  >
    <BuildIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
    <Typography variant="h4" fontWeight={700} gutterBottom>
      Mantenimiento programado
    </Typography>
    <Typography variant="body1" color="text.secondary" maxWidth={480}>
      Estamos realizando mejoras en Isi.ai. Volveremos en unos minutos.
    </Typography>
  </Box>
);

export default MaintenancePage;
